import { useMemo } from 'react';
import { useTg } from './useTelegram';

export interface TgUser {
  id: number;
  first_name: string;
  last_name?: string;
  username?: string;
  language_code?: string;
  is_premium?: boolean;
  photo_url?: string;
}

export function useTgUser(): TgUser | null {
  const tg = useTg();
  return useMemo(() => {
    const u = tg?.initDataUnsafe?.user;
    return u ? (u as TgUser) : null;
  }, [tg]);
}

export function useTgInitData(): string | null {
  const tg = useTg();
  return tg?.initData ?? null;
}
